import i18n from '../i18n';
import { lookupTranslatedName } from './languageCatalog';

/**
 * returns translated name if one exists, else a default name.
 * @param {{ [languageCode]: translatedName }} translatedNames
 * @param {string} defaultName
 */
function getTranslatedName(translatedNames, defaultName) {
  return lookupTranslatedName(translatedNames, i18n.language, defaultName);
}

export default getTranslatedName;
